export const LOGIN_SUCCESS = 'USER.LOGIN_SUCCESS';
export const LOGIN_FAILED = 'USER.LOGIN_FAILED';
export const SIGNOUT = 'USER.SIGNOUT';
export const SET_USER = 'USER.SET_USER';
export const SET_CHECKSTATUS = 'USER.SET_CHECKSTATUS';
export const UPDATE_IMAGE = 'USER.UPDATE_IMAGE';
